import React from 'react';
import Loading from '../components/Loading';
import { ListStyled, ListItem } from '../../css/styles/list';
import { IoMdTrash } from 'react-icons/io';
import { FormStyled } from '../../css/styles/form';
const listItem = props =>
  props.technicalReports.map(item => (
    <ListItem color="#011826" strongColor="#fff" key={item.uuid}>
      <div
        className="info"
        onClick={e => {
          props.onEdit(item);
        }}
      >
        <div>
          <strong className="title">DESCRIÇÃO: </strong>
          <strong>{item.description ? item.description : '-'}</strong>
        </div>
        <div>
          <strong className="title">DATA: </strong>
          <strong>
            {new Date(item.createdAt).toLocaleDateString('pt-BR', {
              timeZone: 'UTC',
            })}
          </strong>
        </div>
        <div>
          <strong className="title">EMPREGADO: </strong>
          <strong>{item?.employee?.name ? item?.employee?.name : '-'}</strong>
        </div>
        <div>
          <strong className="title">VEÍCULO: </strong>
          <strong>
            {item.equipment
              ? `
                ${item.equipment.code}
                
              `
              : '-'}
          </strong>
        </div>
      </div>

      <button
        type="button"
        onClick={e => {
          e.stopPropagation();
          props.onDelete(item.uuid);
        }}
        className="delete"
      >
        <IoMdTrash size={20} color="#bf1523" />
      </button>
    </ListItem>
  ));

function TechnicalReportList(props) {
  const { technicalReports, loadingList } = props;
  return (
    <>
      {!props.loadingList ? (
        props.technicalReports.length > 0 ? (
          <ListStyled>
            <header>
              <div className="total">
                <h1>TOTAL:</h1>
                <p>{technicalReports.length}</p>
              </div>
            </header>

            {listItem(props)}
          </ListStyled>
        ) : (
          <strong>LISTA VAZIA</strong>
        )
      ) : (
        <strong>LISTA VAZIA</strong>
      )}
    </>
  );
}

export default TechnicalReportList;

